import BaseCustomControl from 'components/Map/Controls/CustomControls/BaseCustomControl';
import React from 'react';

interface Props {
	title?: string;
	active?: boolean;
	handleClick?: () => void;
}

const ReportedAvalanchesControl: React.FC<Props> = ({
	title,
	handleClick,
	active = false,
}) => {
	function toggleReportedAvalanchesLayer() {}

	return (
		<BaseCustomControl
			icon="reportedAvalanches"
			title={title}
			handleControl={handleClick ?? toggleReportedAvalanchesLayer}
			className="ol-declining-scale"
			labelPosition="left"
			active={active}
		/>
	);
};

export default ReportedAvalanchesControl;
